import { createContext } from "react";

const MenuContext = createContext(null);

export default MenuContext;